export const GAME_MODES = {
  bff: {
    id: "bff",
    name: "BFF",
    icon: "Users",
    description: "Fun & silly dares with friends",
    fullDescription:
      "Perfect for game nights. Embarrassing but friendship-safe challenges.",
    minPlayers: 2,
    maxPlayers: 6,
    defaultDuration: 20,
    color: "cyan",
    systemPromptKey: "bff",
    intensity: 1,
    inventoryOptions: [
      "Phone",
      "Social Media",
      "Food Items",
      "Music Speaker",
      "Camera",
    ],
  },
  date: {
    id: "date",
    name: "Date",
    icon: "Heart",
    description: "Flirty dares for dating",
    fullDescription: "Build chemistry with romantic, tension-building dares.",
    minPlayers: 2,
    maxPlayers: 2,
    defaultDuration: 15,
    intensity: 2,
    color: "pink",
    systemPromptKey: "date",
    inventoryOptions: ["Lip Balm", "Music", "Blindfold", "Feather", "Ice"],
  },
  couples: {
    id: "couples",
    name: "Couples",
    icon: "Flame",
    description: "Intimate dares for couples",
    fullDescription: "Spicy, passionate challenges for established couples.",
    minPlayers: 2,
    maxPlayers: 2,
    defaultDuration: 20,
    color: "red",
    systemPromptKey: "couples",
    intensity: 3,
    inventoryOptions: [
      "Silk Ties",
      "Ice Cubes",
      "Leather Crop",
      "Blindfold",
      "Handcuffs",
      "Soft Feathers",
      "Lubricant",
      "Spanking Paddle",
      "Vibrator",
      "Restraints",
      "Drip Wax",
      "Anal Plug",
    ],
  },
};

export const getModeById = (id) => GAME_MODES[id] || GAME_MODES.couples;
